import { useState, useEffect, useCallback } from "react";
import { useNavigate } from "react-router-dom";
import Header from "../../components/Header";
import ModalConfirmLogout from "../../components/ModalConfirmLogout";
import HackerLiveFeed from "../../components/HackerLiveFeed";
import { getAssetUrl } from "../../utils/assetUrl";
import "./HomePage.css";

const GAME_CARDS = [
  {
    id: "nohu",
    title: "TOOL NỔ HŨ",
    image: "/assets/nohu.png",
    to: "/NH",
  },
  {
    id: "bcr",
    title: "TOOL BACCARAT",
    image: "/assets/bcr.png",
    to: "/casino/lobby",
  },
  {
    id: "banca",
    title: "TOOL BẮN CÁ",
    image: "/assets/banca.png",
    to: "/fishing",
  },
] as const;

const HomePage = () => {
  const navigate = useNavigate();
  const [isShowLogout, setIsShowLogout] = useState(false);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const onCardClick = useCallback(
    (to: string) => {
      navigate(to);
    },
    [navigate]
  );

  return (
    <div className="x88-hub">
      <div className="x88-hub__header-zone">
        <Header setIsShowLogout={() => setIsShowLogout(true)} />
      </div>

      <main className="x88-hub__main">
        <section className="x88-hub__hero" aria-label="Giới thiệu">
          <h1 className="x88-hub__hero-title">CÔNG NGHỆ AI ĐỘC QUYỀN CỦA X88</h1>
          <p className="x88-hub__hero-chip">&gt;CHỌN GAME ĐỂ BẮT ĐẦU&lt;</p>
        </section>

        <section className="x88-hub__cards-zone" aria-label="Chọn game">
          <div className="x88-hub__cards">
            {GAME_CARDS.map((card) => (
              <button
                key={card.id}
                type="button"
                className="x88-hub__card"
                onClick={() => onCardClick(card.to)}
              >
                <div className="x88-hub__card-frame">
                  <img
                    className="x88-hub__card-img"
                    src={getAssetUrl(card.image)}
                    alt={card.title}
                  />
                </div>
              </button>
            ))}
          </div>
        </section>
      </main>

      <HackerLiveFeed side="left" variant="live" />
      <HackerLiveFeed side="right" variant="terminal" />

      <ModalConfirmLogout
        isShowLogout={isShowLogout}
        setIsShowLogout={() => setIsShowLogout(false)}
      />
    </div>
  );
};

export default HomePage;
